import { Role } from './roles';

/** JWT roles allowed on classic GT routes (`/landing`, `/teacher`, …). Excludes PARA-only roles. */
export const GT_SHELL_ROUTE_ROLES: readonly Role[] = [
	Role.Teacher,
	Role.Principal,
	Role.Area,
	Role.Admin,
	Role.AdminLite,
];
